import React from "react";
import useStyles from "./styles";
import { Grid, Tabs, Tab, Typography } from "@material-ui/core";
import { BreadcrumbsCustom } from "../component";
import ChevronRightRoundedIcon from "@material-ui/icons/ChevronRightRounded";
import clsx from "clsx";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    const classes = useStyles();

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Grid classes={{ root: classes.rootContainerTab }}>{children}</Grid>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        "aria-controls": `vertical-tabpanel-${index}`,
    };
}

const TabsCategory = ({ dataTabsCategory }) => {
    const [value, setValue] = React.useState(0);
    const classes = useStyles();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <>
            <Grid container classes={{ root: classes.rootContainer }}>
                <Grid item xs={12} sm={12} md={3}>
                    <Tabs
                        orientation="vertical"
                        variant="scrollable"
                        value={value}
                        onChange={handleChange}
                        // aria-label="Vertical tabs example"
                        classes={{
                            indicator: classes.indicator,
                            root: classes.rootTabs,
                            scroller: classes.tabScroller,
                            flexContainerVertical: classes.flexContainerVertical,
                        }}
                    >
                        {dataTabsCategory.length !== 0 &&
                            dataTabsCategory.map((item, idx) => (
                                <Tab
                                    key={idx}
                                    className={clsx(
                                        classes.rootTab,
                                        dataTabsCategory[0].type &&
                                            dataTabsCategory[0].type === "Survey"
                                            ? classes.rootTabSurvey
                                            : classes.rootTabLC
                                    )}
                                    classes={{
                                        selected: classes.tabSelected,
                                        wrapper: classes.tabWrapper,
                                    }}
                                    label={item.label}
                                    {...a11yProps(idx)}
                                />
                            ))}
                    </Tabs>
                </Grid>
                <Grid item xs={12} sm={12} md={9} lg={5}>
                    {dataTabsCategory.length !== 0 &&
                        dataTabsCategory.map((item, idx) => (
                            <TabPanel key={idx} value={value} index={idx}>
                                {item.breadcrumbsData && (
                                    <Grid
                                        container
                                        alignItems="center"
                                        classes={{ root: classes.rootContainerBreadcrumb }}
                                    >
                                        <BreadcrumbsCustom breadcrumbsData={item.breadcrumbsData} />
                                        {item.breadcrumbsData.length === 1 && (
                                            <ChevronRightRoundedIcon />
                                        )}
                                    </Grid>
                                )}
                                {item.description && (
                                    <Typography
                                        className={clsx(classes.rootTypography, dataTabsCategory[0].type && dataTabsCategory[0].type === "Reward" && classes.rootTypographyReward)}
                                    >
                                        {item.description}
                                    </Typography>
                                )}

                                {item.component}
                            </TabPanel>
                        ))}
                </Grid>
            </Grid>
        </>
    );
};

export default TabsCategory;
